'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './slider-editor.routes';

export class SliderEditorComponent {

  constructor($uibModal, SettingsService, dialogs) {
    'ngInject';
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.SettingsService = SettingsService;

    this.sortableOptions = {
      handle: '.handle'
    };

    SettingsService.getByName({name: 'carousel-main'}, setting => {
      this.setting = setting;
      this.slider = setting.data;
    })
  }

  removeSlide($event, idx) {
    $event.stopPropagation();

    var dlg = this.dialogs.confirm("Delete Slide?", "Do you really want to delete the "+(idx+1) + ". slide?");
    dlg.result.then(() => {
      this.slider.slides.splice(idx,1);
    }, () => {
      // Cancel
    });

  }

  openSliderUpload() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      size: 'lg',
      component: 'sliderUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function (storageId) {
        that.slider.slides.push({
          active: '',
          image: "/api/storage/public/"+ storageId
        });
      },
      function () { /* cancel */ }
    );

  }

  save() {
    this.setting.data = this.slider;
    this.SettingsService.update({id: this.setting._id}, this.setting, _ => {
      this.dialogs.notify("Success","The slider has been updated successfully");
    }, err => {
      console.log('There has been an error.')
    });
  }
}

export default angular.module('conduu.sliderEditor', [uiRouter])
  .config(routes)
  .component('sliderEditor', {
    template: require('./slider-editor.html'),
    controller: SliderEditorComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/slider/slider-editor.component.js